export default "__VITE_ASSET__5reOfUQn__"